import React, { useEffect, useRef } from "react";
import { 
  FaProjectDiagram, FaUserTie, FaHandshake, FaLeaf, 
  FaUsers, FaRegClock, FaLightbulb, FaBuilding, FaDraftingCompass 
} from "react-icons/fa";
import "./Creditability.css";

function Creditability() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          const cards = document.querySelectorAll('.VerticalCard');
          cards.forEach((card, index) => {
            setTimeout(() => {
              card.style.animation = 'cardAppear 1.2s ease-out forwards';
            }, index * 300); // 300ms delay between each card
          });
        }
      },
      { threshold: 0.2 } // Trigger when 20% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const items = [
    { icon: <FaProjectDiagram />, name: "Diverse Portfolio" },
    { icon: <FaUserTie />, name: "Certified Professionals" },
    { icon: <FaHandshake />, name: "Collaborative Approach" },
    { icon: <FaLeaf />, name: "Years of Experience" },
    { icon: <FaUsers />, name: "Client-Centric Focus" },
    { icon: <FaRegClock />, name: "On-Time and On-Budget" },
    { icon: <FaLightbulb />, name: "Innovative Solutions" },
    { icon: <FaLeaf />, name: "Sustainable Practices" }
  ];

  return (
    <section className="creditability" id="creditability" ref={sectionRef}>
      {/* 🔥 Animated Background Icons */}
      <div className="background-icons">
        <FaBuilding className="bg-icon icon1"/>
        <FaDraftingCompass className="bg-icon icon2"/>
        <FaProjectDiagram className="bg-icon icon3"/>
        <FaLightbulb className="bg-icon icon4"/>
        <FaUsers className="bg-icon icon5"/>
      </div>

      <div className="section-header">
        <h1 className="section-heading">Our Creditability</h1>
        <div className="underline"></div>
      </div>

      <div className="creditCards">
        {items.map((item, index) => (
          <div className="VerticalCard" key={index}>
            <div className="icon-circle">{item.icon}</div>
            <div className="name">{item.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Creditability;